import * as React from 'react'

import MessageReactions from './message-reactions'

import { MessageEmojiData, MessageReaction, MessageReactionType } from '@/types/chat.type'
import { UserProfile } from '@/types/user.type'

export const hasMessageReactions = (reactions: MessageReaction[] | undefined): boolean =>
  (reactions?.length ?? 0) > 0

export const getMessageReactionRowClassName = (isOwnMessage: boolean): string =>
  `mt-1 flex ${isOwnMessage ? 'justify-end' : 'justify-start'}`

interface MessageReactionIconsRowProps {
  messageId: number
  reactions: MessageReaction[]
  onReact?: (messageId: number, reactionType: MessageReactionType, emojiData?: MessageEmojiData) => void
  currentUser?: UserProfile
  isOwnMessage: boolean
  isSystemMessage?: boolean
}

export const MessageReactionIconsRow: React.FC<MessageReactionIconsRowProps> = ({
  messageId,
  reactions,
  onReact,
  currentUser,
  isOwnMessage,
  isSystemMessage = false,
}) => {
  if (isSystemMessage || !onReact || !hasMessageReactions(reactions)) {
    return null
  }

  return (
    <div className={getMessageReactionRowClassName(isOwnMessage)}>
      <MessageReactions
        messageId={messageId}
        reactions={reactions}
        onReact={onReact}
        currentUser={currentUser}
        isOwnMessage={isOwnMessage}
        iconsOnly={true}
      />
    </div>
  )
}

interface MessageReactionContainerProps {
  messageId: number
  reactions: MessageReaction[]
  onReact: (messageId: number, reactionType: MessageReactionType, emojiData?: MessageEmojiData) => void
  currentUser?: UserProfile
  isOwnMessage: boolean
  isSystemMessage: boolean
}

export const MessageReactionContainer: React.FC<MessageReactionContainerProps> = ({
  messageId,
  reactions,
  onReact,
  currentUser,
  isOwnMessage,
  isSystemMessage,
}) => {
  if (isSystemMessage) {
    return null
  }

  return (
    <div className={`mt-1 ${isOwnMessage ? 'flex justify-end' : ''}`}>
      <MessageReactions
        messageId={messageId}
        reactions={reactions}
        onReact={onReact}
        currentUser={currentUser}
        isOwnMessage={isOwnMessage}
      />
    </div>
  )
}
